module.exports = __webpack_public_path__ + "img/scb-logo.3e9b8cbf.png";